const DESKTOP = 'DESKTOP'
const MOBILE = 'MOBILE'

export { DESKTOP, MOBILE }
